var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-form",
    { attrs: { size: "small" } },
    [
      _c(
        "sui-grid",
        [
          _c(
            "sui-grid-row",
            [
              _c(
                "sui-grid-column",
                { attrs: { width: 16 } },
                [
                  _c(
                    "sui-form-field",
                    [
                      _c("label", [_vm._v("Name")]),
                      _c(
                        "sui-form-fields",
                        { attrs: { "equal-width": "" } },
                        [
                          _c("sui-form-field", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.staffMember.First_Name__c,
                                  expression: "staffMember.First_Name__c",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "first-name",
                                placeholder: "First",
                              },
                              domProps: {
                                value: _vm.staffMember.First_Name__c,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.staffMember,
                                    "First_Name__c",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _c("sui-form-field", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.staffMember.Middle_Name__c,
                                  expression: "staffMember.Middle_Name__c",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "middle-name",
                                placeholder: "Middle",
                              },
                              domProps: {
                                value: _vm.staffMember.Middle_Name__c,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.staffMember,
                                    "Middle_Name__c",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _c("sui-form-field", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.staffMember.Name,
                                  expression: "staffMember.Name",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "last-name",
                                placeholder: "Last",
                              },
                              domProps: { value: _vm.staffMember.Name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.staffMember,
                                    "Name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _c("sui-form-field", { attrs: { width: "five" } }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.staffMember.Suffix__c,
                                  expression: "staffMember.Suffix__c",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "suffix",
                                placeholder: "Suffix",
                              },
                              domProps: { value: _vm.staffMember.Suffix__c },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.staffMember,
                                    "Suffix__c",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("sui-form-fields", {
                attrs: { fields: "two", "equal-width": "" },
              }),
            ],
            1
          ),
          _c(
            "sui-grid-row",
            [
              _c(
                "sui-grid-column",
                { attrs: { width: 8 } },
                [
                  _c("sui-form-field", [
                    _c("label", [_vm._v("Title")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.staffMember.Title__c,
                          expression: "staffMember.Title__c",
                        },
                      ],
                      attrs: {
                        type: "text",
                        name: "title",
                        placeholder: "Title",
                      },
                      domProps: { value: _vm.staffMember.Title__c },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.staffMember,
                            "Title__c",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "sui-grid-column",
                { attrs: { width: 8 } },
                [
                  _c("sui-form-field", [
                    _c("label", [_vm._v("Phone")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.staffMember.WorkPhone__c,
                          expression: "staffMember.WorkPhone__c",
                        },
                      ],
                      attrs: {
                        type: "text",
                        name: "phone",
                        placeholder: "Phone",
                      },
                      domProps: { value: _vm.staffMember.WorkPhone__c },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.staffMember,
                            "WorkPhone__c",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("sui-form-field", [
                    _c("label", [_vm._v("Mobile")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.staffMember.Mobile_Phone__c,
                          expression: "staffMember.Mobile_Phone__c",
                        },
                      ],
                      attrs: {
                        type: "text",
                        name: "first-name",
                        placeholder: "First",
                      },
                      domProps: { value: _vm.staffMember.Mobile_Phone__c },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.staffMember,
                            "Mobile_Phone__c",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("sui-form-field", [
                    _c("label", [_vm._v("Email")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.staffMember.WorkEmail__c,
                          expression: "staffMember.WorkEmail__c",
                        },
                      ],
                      attrs: {
                        type: "email",
                        name: "email",
                        placeholder: "Email",
                      },
                      domProps: { value: _vm.staffMember.WorkEmail__c },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.staffMember,
                            "WorkEmail__c",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "sui-grid-row",
            [
              _c(
                "sui-grid-column",
                { attrs: { width: 8 } },
                [
                  _c(
                    "sui-form-field",
                    [
                      _c("label", [_vm._v("Work Address")]),
                      _c("sui-form-field", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.staffMember.WorkAddressLine1__c,
                              expression: "staffMember.WorkAddressLine1__c",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "work-address-line-1",
                            placeholder: "Address line 1",
                          },
                          domProps: {
                            value: _vm.staffMember.WorkAddressLine1__c,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.staffMember,
                                "WorkAddressLine1__c",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("sui-form-field", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.staffMember.WorkAddressLine2__c,
                              expression: "staffMember.WorkAddressLine2__c",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "work-address-line-2",
                            placeholder: "Address line 2",
                          },
                          domProps: {
                            value: _vm.staffMember.WorkAddressLine2__c,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.staffMember,
                                "WorkAddressLine2__c",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c(
                        "sui-form-fields",
                        { attrs: { "equal-width": "" } },
                        [
                          _c("sui-form-field", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.staffMember.WorkCity__c,
                                  expression: "staffMember.WorkCity__c",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "city",
                                placeholder: "City",
                              },
                              domProps: { value: _vm.staffMember.WorkCity__c },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.staffMember,
                                    "WorkCity__c",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _c(
                            "sui-form-field",
                            [
                              _c("sui-dropdown", {
                                attrs: {
                                  placeholder: "State",
                                  selection: "",
                                  search: "",
                                  options: _vm.states,
                                },
                                model: {
                                  value: _vm.staffMember.WorkState__c,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.staffMember,
                                      "WorkState__c",
                                      $$v
                                    )
                                  },
                                  expression: "staffMember.WorkState__c",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("sui-form-field", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.staffMember.WorkPostalCode__c,
                                  expression: "staffMember.WorkPostalCode__c",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "home-postal-code",
                                placeholder: "Zip Code",
                              },
                              domProps: {
                                value: _vm.staffMember.WorkPostalCode__c,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.staffMember,
                                    "WorkPostalCode__c",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }